<template>
  <div class="hello">
    <div class="title1">绑定手机号</div>
    <div class="input-form">
      <div class="input-container">
        <img src="../../../static/wechat/iconPhone.png" />
        <input
          placeholder="请输入手机号"
          v-model="request.userphone"
          maxlength="11"
        />
      </div>
      <div class="input-container">
        <img src="../../../static/wechat/iconCode.png" />
        <input
          v-model="request.userpwd"
          class="loginContent input"
          placeholder="请输入密码"
          :type="showPassword ? 'text' : 'password'"
        /><br />
        <img :src="showPassword ? '../../../static/wechat/eyeShow.png' : '../../../static/wechat/eyeClose.png'" @click="showPassword = !showPassword" />
      </div>
      
      <button class="btn-submit" @click="bindWeChat">立即登录</button>
    </div>
    <div class="wechat-overlay" v-show="isShow">
      <div class="wechat-dialog">
        <div class="wechat-dialog-close" @click="isShow = false"></div>
        <div class="wechat-dialog-content">
          <div class="title2" v-if="datacode == 200">
            确认将微信绑定以下账号？
          </div>
          <div class="title2" v-if="datacode == 202">
            您输入的手机号{{ request.userphone }}<br />已绑定其他微信
          </div>
          <div class="wechat-user-logo" v-if="user.userlogo">
            <img :src="user.userlogo" />
          </div>
          <div class="title2">{{ user.username }}</div>
        </div>
        <div class="wechat-dialog-footer">
          <button v-if="datacode == 200" @click="sureBind">确认绑定</button>
          <button v-if="datacode == 202" @click="isShow = false">取消</button>
          <button v-if="datacode == 202" class="btn-gray" @click="sureBind">
            替换绑定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const TIME_COUNT = 60;
import CryptoJS from 'crypto-js';
import { Toast, MessageBox } from "mint-ui";
export default {
  name: "bindPhone",
  data() {
    return {
      count: "获取验证码",
      timer: null,
      isShow: false,
      datacode: 0, //200：账号可以绑定，202：账号已经被其他微信绑定
      request: {
        userphone: "",
        userpwd: "",
        platformId: "",
        codes: ""
      },
      bindRequest: {
        openId: "",
        phone: ""
      },
      user: {},
      getUserPlatformlist: [],
      codeUrl: "", //验证码图片
      codeKey: "",

      showPassword: false
    };
  },
  mounted() {
    this.bindRequest.openId = this.$route.query.openId;
    this.bindRequest.phone = this.$route.query.phone;
  },
  methods: {
    encryptByDES(message) {
			var keyHex = CryptoJS.enc.Utf8.parse('12345678');
			var ivHex = CryptoJS.enc.Utf8.parse('12345678');
			var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
				iv: ivHex,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7,
			});

			return encrypted.toString();
		},
		deCodeDES(message) {
			var keyHex = CryptoJS.enc.Utf8.parse('12345678');
			var ivHex = CryptoJS.enc.Utf8.parse('12345678');
			var dec = CryptoJS.DES.decrypt(message.toString(), keyHex, {
				iv: ivHex,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7,
			});
			return dec.toString(CryptoJS.enc.Utf8);
		},
    bindWeChat() {
      if (this.request.userphone == "") {
        Toast("请输入手机号");
        return;
      }
      if (this.request.userpwd == "") {
        Toast("请输入密码");
        return;
      }
      this.getUserInfo();
      //调用接口查询要绑定的用户信息
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      var _t = this;
      this.common.doAction(
        _t.common.mdbindBeforeWithPassword,
        {
          ..._t.request,
          userpwd: this.encryptByDES(_t.request.userpwd)
        },
        function(res) {
          if (res.code == 200 || res.code == 202) {
            _t.datacode = res.code;
            _t.isShow = true;
            if (res.code == 202) {
              _t.user.username = res.data.nickname;
              _t.user.userlogo = res.data.headImgUrl;
            } else {
              _t.user.username = res.data.username;
              _t.user.userlogo = res.data.userlogo;
            }
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "wxapi"
      );
    },
    sureBind() {
      var _t = this;
      // this.bindRequest.phone = this.request.phone;
      this.bindRequest.phone = this.request.userphone;
      this.bindRequest.platformId = this.request.platformId;
      this.common.doActionGet(
        this.common.bindLnyNew,
        this.bindRequest,
        function(res) {
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            var query = {
              openId: _t.bindRequest.openId,
              phone: _t.bindRequest.phone
            };
            // _t.$router.push({
            //   path: "/bindDetailnew",
            //   query: query
            // });
            _t.$router.push({
              path: "/platformnew",
              query: query
            });
          } else {
            MessageBox.alert("ERROR", res.msg);
          }
        },
        "wxapi"
      );
    }
  }
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
}
.title1 {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-top: 60px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 10px;
}
.input-form {
  margin-top: 70px;
  height: 120px;
}
.input-container {
  height: 24px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  align-items: center;
}
.input-container img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.input-container input {
  border: none;
  flex-grow: 1;
  height: 24px;
  line-height: 24px;
  min-width: 100px;
  font-size: 14px;
}
.btn-code {
  /* width: 100px; */
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
  flex: 0 0 80px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/wechat/bindPhoneno.vue